import { DeactivateSubaccountRequest } from 'vopay';
import { useEffect } from 'react';
import axios from 'axios';
import vopayApi from '@/services/api.config';
const { api } = vopayApi;

export default function useDeactivateSubAccount() {
  const source = axios.CancelToken.source();

  useEffect(() => {
    return () => {
      source.cancel();
    };
  }, []);

  const deactivateSubaccount = async (request: DeactivateSubaccountRequest) => {
    try {
      const res = await api.deactivateSubaccount(request, source);
      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (err) {
      console.error(err);
      throw err;
    }
  };

  return {
    deactivateSubaccount,
  };
}
